import { APIURL as apiURL } from "./api-base";

//const apiVersion = '/v1';

const apiUrl_payment = "/api/payments";

export const apiUrl_workshop = "/api/workshops";
export const apiUrl_workshop_lives = "/api/workshops/lives";
export const apiUrl_workshop_users = "/api/workshops/users/";
// export const apiUrl_workshop_update = '/api/workshops/edit_workshop';
export const apiUrl_workshop_status = "/api/workshops/jobStatus/all";

// USERS
export const apiUrl_user = "/api/users/all";
export const apiUrl_user_singup = "/api/users/singup";
export const apiUrl_user_signin = "/api/users/signin";
export const apiUrl_user_id = "/api/users/getbyid";
export const apiUrl_user_permissions = "/api/users";
export const apiUrl_user_update = "/api/users/edit_user";
export const apiUrl_user_update_status = "/api/users/setAdmin";
export const apiUrl_user_validate = "/api/users/validate";
export const apiUrl_user_add_membership = "/api/users/addUserMembership";
export const apiUrl_user_delete_membership = "/api/users/removeUserMembership";

// export const apiUrl_user_validate = "/api/users/validate"

//Payments
export const apiUrl_payment_confirm_tranfer =
  apiUrl_payment + "/transfer/confirm/";
export const apiUrl_payment_create =
  apiUrl_payment + "/create";
export const all_payments = "/api/payments/all";
export const apiUrl_payment_cancel_tranfer =
  apiUrl_payment + "/transfer/cancel/";
export const apiUrl_payment_tranfer = apiUrl_payment + "/transfer/";
export const apiUrl_payment_workshop = apiUrl_payment + "/byworkshop/";
export const apiUrl_payment_user = apiUrl_payment + "/byuser/";
export const apiUrl_payment_external_mp = apiUrl_payment + "/mercadopago/getStatusFromApi/";
export const apiUrl_payment_external_paypal = apiUrl_payment + "/paypal/getStatusFromApi/";

// Calendar
export const apiUrl_calendar = "/api/calendar";

// Recipes
export const apiUrl_recipes = "/api/recipes";

// Bank
export const apiUrl_bank = "/api/bank";

// Profile
export const apiUrl_profile = "/api/profile";

//Lives
export const apiUrl_lives = "/api/lives";
export const apiUrl_update_thumbnail_live = "/api/lives/thumbnail";
export const apiURL_live_start_notification = "/api/lives/liveStart";

//export const apiUrl_handleUserPremium = "/api/users/handleUserPremium";

// Channels
export const apiUrl_channel = "/api/chats/getChannels";
export const apiUrl_channel_moderator = "/api/chats/getModsByChannel";
export const apiUrl_channel_history = "/api/chats/getChatFromChannelToday";

//Chat Live
export const apiURL_get_chat_live = "/api/chats/getLiveChatDates";
export const apiURL_get_chat_live_by_date = "/api/chats/getLiveChats";

//Admin
export const apiURL_admin = "/api/admin";
export const apiURL_admin_getAll = apiURL_admin + "/getAll";
export const apiURL_admin_by_id = apiURL_admin + "/getOne";
export const apiURL_admin_login = apiURL_admin + "/signin";
export const apiURL_admin_create = apiURL_admin + "/createAdminUser";
export const apiURL_admin_update =
  apiURL_admin + "/permissions/manageUserPermissions";
export const apiURL_admin_update_user = apiURL_admin + "/updated";
export const apiURL_admin_delete = apiURL_admin + "/desactivateAdmin";

//Products
export const apiUrl_product = "/api/product";

//Cupons
export const apiUrl_cupons = "/api/coupon";

//Moderators
export const apiURL_getAll_moderators = "api/users/getModsAndChannels";
export const apiURL_create_moderators = "api/chats/assignMod";
export const apiURL_delete_moderator = "api/chats/unAssignMod";

//PopUps
export const apiUrl_popups = "/api/popup";

//Reports
export const apiUrl_lives_comments_reports = '/api/library/comments/reports'
export const apiUrl_eco_reports = '/api/eco-reports'

//Links Sireniles
export const apiUrl_links = '/api/links'

//Live Categories
export const apiUrl_liveCategories = '/api/live-categories'

//Statistics
export const apiUrl_statistics_total_post = '/api/statistics/total-post'
export const apiUrl_statistics_total_active_memberships = '/api/statistics/total-active-memberships'
export const apiUrl_statistics_total_first_time_active_members = '/api/statistics/total-first-time-active-members'
export const apiUrl_statistics_total_returning_active_members = '/api/statistics/total-returning-active-members'
export const apiUrl_statistics_active_memberships_by_year = '/api/statistics/active-memberships-by-year'
export const apiUrl_statistics_active_memberships_by_month = '/api/statistics/active-memberships-by-month'
export const apiUrl_statistics_active_memberships_by_product = '/api/statistics/active-memberships-by-product'
export const apiUrl_statistics_active_memberships_by_day = '/api/statistics/active-memberships-by-day'
export const apiUrl_statistics_membership_managed_years = '/api/statistics/membership-managed-years'

//MediaLive
export const apiUrl_medialive_describe = '/api/medialive/describe'
export const apiUrl_medialive_metrics = '/api/medialive/metrics'
export const apiUrl_medialive_start = '/api/medialive/start'
export const apiUrl_medialive_stop = '/api/medialive/stop'
export const apiUrl_medialive_last_mp4 = '/api/medialive/last-live/mp4'
export const apiUrl_medialive_last_mp4_status = '/api/medialive/last-live/mp4/status'
